import React from 'react';
export function TempLockoutTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-644">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-645">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-646" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-647">
        <h1 style={{
        fontSize: '24px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '16px',
        marginTop: '0'
      }} data-id="element-648">
          Account temporarily locked
        </h1>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-649">
          Hello,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '24px'
      }} data-id="element-650">
          Your Aisco Workspace account has been temporarily locked due to
          multiple failed login attempts.
        </p>

        <div style={{
        backgroundColor: '#fef2f2',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #dc2626',
        marginBottom: '32px'
      }} data-id="element-651">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#991b1b',
          marginTop: '0',
          marginBottom: '12px'
        }} data-id="element-652">
            Security Measure
          </h3>
          <p style={{
          margin: '0 0 12px 0',
          color: '#7f1d1d',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-653">
            This is a security measure to protect your account from unauthorized
            access attempts.
          </p>
          <p style={{
          margin: '0',
          color: '#7f1d1d',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-654">
            <strong data-id="element-655">Lockout duration:</strong> 30 minutes
          </p>
        </div>

        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #2563eb',
        marginBottom: '32px'
      }} data-id="element-656">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#1e40af',
          marginTop: '0',
          marginBottom: '12px'
        }} data-id="element-657">
            What happens next:
          </h3>
          <ul style={{
          margin: '0',
          paddingLeft: '20px',
          color: '#1e40af',
          fontSize: '14px',
          lineHeight: '1.8'
        }} data-id="element-658">
            <li data-id="element-659">Your account will be automatically unlocked in 30 minutes</li>
            <li data-id="element-660">You can try logging in again after the lockout period</li>
            <li data-id="element-661">
              If you forgot your password, you can reset it using the button
              below
            </li>
          </ul>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-662">
          If you didn't attempt to log in, someone may be trying to access your
          account. We recommend changing your password immediately.
        </p>

        {/* CTA Buttons */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-663">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600',
          marginBottom: '12px'
        }} data-id="element-664">
            Reset my password
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-665">
          Need immediate assistance? Contact{' '}
          <a href="mailto:support@aisco.com" style={{
          color: '#2563eb',
          textDecoration: 'none'
        }} data-id="element-666">
            support@aisco.com
          </a>
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-667">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-668">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-669" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}